"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _NavigateBackButton = require("@ccw-pwa-ui/NavigateBackButton");
var _Modal = require("@ccw-pwa-ui/Modal");
var _HeaderText = require("@ccw-pwa-ui/HeaderText");
var _Button = require("@ccw-pwa-ui/Button");
require("../styles/QrCodeComponent.css");
var _images = _interopRequireDefault(require("../common_features/assets/images"));
const QrCodeComponent = props => {
  const {
    navHeading,
    rightNavHeading,
    handleCancle,
    handleBack,
    headerText,
    subContent,
    btnTitle,
    bottomContent,
    bottomBtnTitle,
    qrDisabled,
    noQrDisabled,
    navigateToProvisioningDevice,
    qrscanBtn,
    modalData
  } = props;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "add-system-qr-code-wrapper"
  }, /*#__PURE__*/_react.default.createElement(_NavigateBackButton.NavigateBackButton, {
    navHeading: navHeading,
    rightNavHeading: rightNavHeading,
    handleCancle: handleCancle,
    handleBack: handleBack,
    leftArrowImage: _images.default.leftArrow.default
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "qr-code-body-wrapper"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "add-system-qr-code-body"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "add-system-qr-heading"
  }, /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
    variant: "header-text",
    headerText: headerText
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "add-system-qr-sub-content"
  }, /*#__PURE__*/_react.default.createElement("p", null, subContent)), /*#__PURE__*/_react.default.createElement("div", {
    className: "qrscan-btn-div",
    "data-testid": "qrscan-btn-div"
  }, /*#__PURE__*/_react.default.createElement(_Button.Button, {
    variant: "primary-long",
    title: btnTitle,
    onClick: qrscanBtn,
    disabled: qrDisabled
  })), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
    className: "add-system-qr-bottom-content"
  }, /*#__PURE__*/_react.default.createElement("p", null, bottomContent)), /*#__PURE__*/_react.default.createElement("div", {
    className: "add-system-no-qr-btn"
  }, /*#__PURE__*/_react.default.createElement(_Button.Button, {
    variant: "outline-primary-long",
    title: bottomBtnTitle,
    onClick: navigateToProvisioningDevice,
    disabled: noQrDisabled
  }))))), props.showModal && /*#__PURE__*/_react.default.createElement(_Modal.Modal, {
    displayModal: props.showModal,
    variant: modalData === null || modalData === void 0 ? void 0 : modalData.variant,
    displayCrossIcon: modalData === null || modalData === void 0 ? void 0 : modalData.displayCrossIcon,
    modalHeaderText: modalData === null || modalData === void 0 ? void 0 : modalData.modalHeaderText,
    modalHeaderTextStyle: modalData === null || modalData === void 0 ? void 0 : modalData.modalHeaderTextStyle,
    modalHeaderIcon: true,
    modalDetailText: modalData === null || modalData === void 0 ? void 0 : modalData.modalDetailText,
    modalDetailTextStyle: modalData === null || modalData === void 0 ? void 0 : modalData.modalDetailTextStyle,
    positiveActionButtonTitle: modalData === null || modalData === void 0 ? void 0 : modalData.positiveActionButtonTitle,
    negativeButtonActionTitle: modalData === null || modalData === void 0 ? void 0 : modalData.negativeButtonActionTitle,
    positiveAction: modalData === null || modalData === void 0 ? void 0 : modalData.positiveAction,
    negativeAvtion: modalData === null || modalData === void 0 ? void 0 : modalData.negativeAction,
    crossIconAction: modalData === null || modalData === void 0 ? void 0 : modalData.crossIconAction
  }));
};
var _default = exports.default = QrCodeComponent;